<script>
import CaretWrapper from './caret.vue'
import ResizeBar from './resize.vue'
import { getFixedStyle, getColumnWidth } from './utils'
export default {
  name: 'RkTableThead',
  components: { CaretWrapper, ResizeBar },
  props: ['store', 'hasEdgePadding'],
  computed: {
    columns() {
      return this.store.columns
    },
    currentSort() {
      return this.store.sort
    }
  },
  methods: {
    updateColumnWidth(width, index) {
      this.$emit('resize-width', width, index)
    },
    sortChange(column) {
      if (column.sortable) {
        let { prop, order } = this.currentSort
        if (column.prop === prop) {
          order = order === 'asc' ? 'desc' : 'asc'
          this.$emit('sort-change', { prop: column.prop, order })
        } else {
          this.$emit('sort-change', { prop: column.prop, order: 'asc' })
        }
      }
    }
  },
  render(createElement) {
    return createElement(
      'div',
      {
        class: {
          'rk-table__header': true
        }
      },
      [
        createElement(
          'div',
          {
            class: {
              'rk-table__row': true,
              'rk-table__row--header': true
            }
          },
          this.columns.map((column, index) => {
            return createElement(
              'div',
              {
                class: {
                  'rk-table__column': true,
                  'edge-left-padding': index === 0 && this.hasEdgePadding,
                  'edge-right-padding': index === this.columns?.length - 1 && this.hasEdgePadding,
                  'rk-table__column--sortable': column.sortable,
                  [`rk-table__column--${column.align}`]: true
                },
                style: {
                  'z-index': column.fixed ? 1 : 0,
                  ...getColumnWidth(column.width),
                  ...getFixedStyle(this.columns, column.fixed, index)
                }
              },
              [
                createElement(
                  'div',
                  {
                    class: {
                      'rk-table__label-wrap': true
                    },
                    on: {
                      click: () => {
                        this.sortChange(column)
                      }
                    }
                  },
                  [
                    createElement(
                      'span',
                      {
                        class: {
                          'rk-table__label': true
                        }
                      },
                      [column.headerSlot.call(null, createElement, { column })]
                    ),
                    column.sortable
                      ? createElement('CaretWrapper', {
                          props: {
                            prop: column.prop,
                            currentSort: this.currentSort
                          }
                        })
                      : null
                  ]
                ),
                createElement('ResizeBar', {
                  props: { index }
                })
              ]
            )
          })
        )
      ]
    )
  }
}
</script>

<style lang="scss" scoped>
.rk-table__label-wrap {
  display: flex;
  align-items: center;
  color: var(--font-color-3);
}
</style>
